var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isLog
        ? _c(
            "el-drawer",
            {
              attrs: {
                title: _vm.title,
                visible: _vm.drawer,
                size: "80%",
                wrapperClosable: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawer = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "form-center",
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        "label-width": "120px",
                        rules: _vm.rules,
                        disabled: _vm.disabled,
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "工单编号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "系统自动生成",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.Code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Code", $$v)
                                      },
                                      expression: "form.Code",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "设备名称",
                                    prop: "DeviceItemName",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "calc(100% - 60px)",
                                        },
                                        attrs: {
                                          placeholder: "请选择设备",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.form.DeviceItemNameJson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "DeviceItemNameJson",
                                              $$v
                                            )
                                          },
                                          expression: "form.DeviceItemNameJson",
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "60px" },
                                          attrs: {
                                            type: "primary",
                                            disabled:
                                              _vm.devInfo.Id || _vm.disabled
                                                ? true
                                                : false,
                                          },
                                          on: { click: _vm.openDevice },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-search",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "工单类型",
                                    prop: "WorkOrderType",
                                  },
                                },
                                [
                                  _c("SelectDicValue", {
                                    attrs: {
                                      code: "WorkOrderType",
                                      disabled: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        ;(_vm.form.Type = ""),
                                          (_vm.form.FaultDescription = "")
                                      },
                                    },
                                    model: {
                                      value: _vm.form.WorkOrderType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "WorkOrderType", $$v)
                                      },
                                      expression: "form.WorkOrderType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.WorkOrderType === "0",
                                  expression: "form.WorkOrderType === '0'",
                                },
                              ],
                              attrs: { span: 8 },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "类型", prop: "Type" } },
                                [
                                  _c("SelectDicValue", {
                                    attrs: { code: "InspectionType" },
                                    model: {
                                      value: _vm.form.Type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Type", $$v)
                                      },
                                      expression: "form.Type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.WorkOrderType === "1",
                                  expression: "form.WorkOrderType === '1'",
                                },
                              ],
                              attrs: { span: 8 },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "类型", prop: "Type" } },
                                [
                                  _c("SelectDicValue", {
                                    attrs: { code: "MaintenanceLevel" },
                                    model: {
                                      value: _vm.form.Type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Type", $$v)
                                      },
                                      expression: "form.Type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.WorkOrderType === "2" ||
                                    _vm.form.WorkOrderType === "3",
                                  expression:
                                    "form.WorkOrderType === '2' || form.WorkOrderType === '3'",
                                },
                              ],
                              attrs: { span: 8 },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "类型", prop: "Type" } },
                                [
                                  _c("SelectDicValue", {
                                    attrs: { code: "TheFaultType" },
                                    model: {
                                      value: _vm.form.Type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "Type", $$v)
                                      },
                                      expression: "form.Type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.form.WorkOrderType === "3"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "供应商",
                                        prop: "Amount",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "calc(100% - 60px)",
                                        },
                                        attrs: {
                                          placeholder: "请选择供应商",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.form.SupplierName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "SupplierName",
                                              $$v
                                            )
                                          },
                                          expression: "form.SupplierName",
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "60px" },
                                          attrs: {
                                            type: "primary",
                                            disabled: _vm.disabled,
                                          },
                                          on: { click: _vm.openSup },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-search",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.form.WorkOrderType === "3"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "合同编号",
                                        prop: "Contract",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          disabled: _vm.disabled,
                                          controls: false,
                                        },
                                        model: {
                                          value: _vm.form.Contract,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "Contract", $$v)
                                          },
                                          expression: "form.Contract",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.form.WorkOrderType === "3"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "费用", prop: "Amount" },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          disabled: _vm.disabled,
                                          controls: false,
                                        },
                                        model: {
                                          value: _vm.form.Amount,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "Amount", $$v)
                                          },
                                          expression: "form.Amount",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "人员信息",
                                    prop: "OperatorIds",
                                  },
                                },
                                [
                                  _c("SelectData", {
                                    attrs: {
                                      multiple: "",
                                      url: "/Base_Manage/Base_User/GetDataList",
                                      option: {
                                        label: "RealName",
                                        Id: "Id",
                                      },
                                    },
                                    model: {
                                      value: _vm.form.OperatorIds,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "OperatorIds", $$v)
                                      },
                                      expression: "form.OperatorIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "工单日期",
                                    prop: "WorkOrderDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "请选择日期",
                                    },
                                    model: {
                                      value: _vm.form.WorkOrderDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "WorkOrderDate", $$v)
                                      },
                                      expression: "form.WorkOrderDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "预计完成日期",
                                    prop: "ExpectDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "请选择日期",
                                    },
                                    model: {
                                      value: _vm.form.ExpectDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "ExpectDate", $$v)
                                      },
                                      expression: "form.ExpectDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.WorkOrderType === "3"
                            ? _c(
                                "el-col",
                                { attrs: { span: 16 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 2,
                                          placeholder: "请输入内容",
                                        },
                                        model: {
                                          value: _vm.form.Annotation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "Annotation",
                                              $$v
                                            )
                                          },
                                          expression: "form.Annotation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "Describe",
                                  attrs: { label: "图片", prop: "HeadImg" },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action:
                                          _vm.$rootUrl +
                                          `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`,
                                        headers: {
                                          Authorization: _vm.token,
                                        },
                                        "file-list": _vm.Imgs,
                                        limit: 5,
                                        "list-type": "picture-card",
                                        "on-preview":
                                          _vm.handlePictureCardPreview,
                                        "on-success": _vm.handleAvatarSuccess,
                                        "on-remove": _vm.handleRemove,
                                        "on-exceed": _vm.handleExceed,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        disabled: _vm.disabled,
                                      },
                                    },
                                    [
                                      !_vm.disabled
                                        ? _c("i", {
                                            staticClass: "el-icon-plus",
                                          })
                                        : _vm._e(),
                                      _vm.disabled
                                        ? _c("i", {
                                            staticClass: "el-icon-close",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.activeNames,
                            callback: function ($$v) {
                              _vm.activeNames = $$v
                            },
                            expression: "activeNames",
                          },
                        },
                        [
                          _vm.form.WorkOrderType === "2" ||
                          _vm.form.WorkOrderType === "3"
                            ? _c(
                                "el-collapse-item",
                                { attrs: { title: "故障描述", name: "1" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#f56c6c" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 故障描述    "),
                                  ]),
                                  _c(
                                    "el-row",
                                    [
                                      _vm.form.WorkOrderType === "2" ||
                                      _vm.form.WorkOrderType === "3"
                                        ? _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: " ",
                                                    prop: "FaultDescription",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "",
                                                      type: "textarea",
                                                      rows: "10",
                                                      resize: "none",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form
                                                          .FaultDescription,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "FaultDescription",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.FaultDescription",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "建议描述", name: "2" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#f56c6c" } },
                                  [_vm._v("*")]
                                ),
                                _vm._v(" 建议描述 "),
                              ]),
                              _c(
                                "el-row",
                                { staticStyle: { "padding-bottom": "50px" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-bottom": "0" },
                                      attrs: { label: " ", prop: "Remarks" },
                                    },
                                    [
                                      !_vm.disabled
                                        ? _c("quill-editor", {
                                            ref: "myQuillEditor",
                                            staticStyle: { height: "600px" },
                                            attrs: {
                                              options: _vm.editorOption,
                                            },
                                            model: {
                                              value: _vm.form.Remarks,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "Remarks",
                                                  $$v
                                                )
                                              },
                                              expression: "form.Remarks",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.disabled
                                        ? _c("div", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "600px",
                                              overflow: "auto",
                                              border: "1px solid #e2e2e2",
                                              padding: "10px",
                                              "background-color": "#f5f7fa",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.form.Remarks
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "备件信息", name: "3" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "line-height": "30px" } },
                                    [
                                      !_vm.disabled
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.addList },
                                            },
                                            [_vm._v("添加备件")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      ref: "MaterialsData",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.MaterialsData,
                                        height: "400px",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "序号",
                                          width: "50",
                                          type: "index",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "备件编号",
                                          align: "center",
                                          prop: "Code",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "备件名称",
                                          align: "center",
                                          prop: "Name",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "备件类型",
                                          align: "center",
                                          prop: "MaterialTypeName",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "备件规格",
                                          align: "center",
                                          prop: "Spec",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "单位",
                                          align: "center",
                                          prop: "storageName",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "货位",
                                          align: "center",
                                          prop: "LocalName",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "库存数量",
                                          align: "right",
                                          prop: "Nums_N",
                                          sortable: "",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "数量",
                                          align: "center",
                                          prop: "Num",
                                          sortable: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      disabled: _vm.disabled,
                                                      type: "number",
                                                      controls: false,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.NumChange(
                                                          $event,
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.Num,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "Num",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.Num",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          478268593
                                        ),
                                      }),
                                      !_vm.disabled
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "操作",
                                              align: "center",
                                              prop: "op",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            color: "#f78989",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.MaterialsData.splice(
                                                                scope.$index,
                                                                1
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("删除")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4135523204
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.close } }, [
                    _vm._v("取消"),
                  ]),
                  !_vm.disabled
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _vm.title == "提交工单"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.handleAudit },
                        },
                        [_vm._v(" 提交")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.isLog && _vm.drawer
        ? _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "120px",
                      rules: _vm.rules,
                      disabled: _vm.disabled,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "工单编号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "系统自动生成",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.form.Code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "Code", $$v)
                                    },
                                    expression: "form.Code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "设备名称",
                                  prop: "DeviceItemName",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "calc(100% - 60px)",
                                      },
                                      attrs: {
                                        placeholder: "请选择设备",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.form.DeviceItemNameJson,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "DeviceItemNameJson",
                                            $$v
                                          )
                                        },
                                        expression: "form.DeviceItemNameJson",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "60px" },
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.devInfo.Id || _vm.disabled
                                              ? true
                                              : false,
                                        },
                                        on: { click: _vm.openDevice },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-search",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "工单类型",
                                  prop: "WorkOrderType",
                                },
                              },
                              [
                                _c("SelectDicValue", {
                                  attrs: {
                                    code: "WorkOrderType",
                                    disabled: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      ;(_vm.form.Type = ""),
                                        (_vm.form.FaultDescription = "")
                                    },
                                  },
                                  model: {
                                    value: _vm.form.WorkOrderType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "WorkOrderType", $$v)
                                    },
                                    expression: "form.WorkOrderType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.WorkOrderType === "0",
                                expression: "form.WorkOrderType === '0'",
                              },
                            ],
                            attrs: { span: 8 },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "类型", prop: "Type" } },
                              [
                                _c("SelectDicValue", {
                                  attrs: { code: "InspectionType" },
                                  model: {
                                    value: _vm.form.Type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "Type", $$v)
                                    },
                                    expression: "form.Type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.WorkOrderType === "1",
                                expression: "form.WorkOrderType === '1'",
                              },
                            ],
                            attrs: { span: 8 },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "类型", prop: "Type" } },
                              [
                                _c("SelectDicValue", {
                                  attrs: { code: "MaintenanceLevel" },
                                  model: {
                                    value: _vm.form.Type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "Type", $$v)
                                    },
                                    expression: "form.Type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.WorkOrderType === "2" ||
                                  _vm.form.WorkOrderType === "3",
                                expression:
                                  "form.WorkOrderType === '2' || form.WorkOrderType === '3'",
                              },
                            ],
                            attrs: { span: 8 },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "类型", prop: "Type" } },
                              [
                                _c("SelectDicValue", {
                                  attrs: { code: "TheFaultType" },
                                  model: {
                                    value: _vm.form.Type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "Type", $$v)
                                    },
                                    expression: "form.Type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _vm.form.WorkOrderType === "3"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "供应商", prop: "Amount" },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "calc(100% - 60px)",
                                      },
                                      attrs: {
                                        placeholder: "请选择供应商",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.form.SupplierName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "SupplierName",
                                            $$v
                                          )
                                        },
                                        expression: "form.SupplierName",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "60px" },
                                        attrs: {
                                          type: "primary",
                                          disabled: _vm.disabled,
                                        },
                                        on: { click: _vm.openSup },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-search",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _vm.form.WorkOrderType === "3"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "合同编号",
                                      prop: "Contract",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "number",
                                        disabled: _vm.disabled,
                                        controls: false,
                                      },
                                      model: {
                                        value: _vm.form.Contract,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "Contract", $$v)
                                        },
                                        expression: "form.Contract",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _vm.form.WorkOrderType === "3"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "费用", prop: "Amount" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "number",
                                        disabled: _vm.disabled,
                                        controls: false,
                                      },
                                      model: {
                                        value: _vm.form.Amount,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "Amount", $$v)
                                        },
                                        expression: "form.Amount",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "人员信息",
                                  prop: "OperatorIds",
                                },
                              },
                              [
                                _c("SelectData", {
                                  attrs: {
                                    multiple: "",
                                    url: "/Base_Manage/Base_User/GetDataList",
                                    option: {
                                      label: "RealName",
                                      Id: "Id",
                                    },
                                  },
                                  model: {
                                    value: _vm.form.OperatorIds,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "OperatorIds", $$v)
                                    },
                                    expression: "form.OperatorIds",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "工单日期",
                                  prop: "WorkOrderDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "value-format": "yyyy-MM-dd",
                                    type: "date",
                                    placeholder: "请选择日期",
                                  },
                                  model: {
                                    value: _vm.form.WorkOrderDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "WorkOrderDate", $$v)
                                    },
                                    expression: "form.WorkOrderDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "预计完成日期",
                                  prop: "ExpectDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "value-format": "yyyy-MM-dd",
                                    type: "date",
                                    placeholder: "请选择日期",
                                  },
                                  model: {
                                    value: _vm.form.ExpectDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "ExpectDate", $$v)
                                    },
                                    expression: "form.ExpectDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 2,
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.form.Annotation,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "Annotation", $$v)
                                    },
                                    expression: "form.Annotation",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "Describe",
                                attrs: { label: "图片", prop: "HeadImg" },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    class: { "disabled-upload": _vm.disabled },
                                    attrs: {
                                      action:
                                        _vm.$rootUrl +
                                        `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`,
                                      headers: {
                                        Authorization: _vm.token,
                                      },
                                      "file-list": _vm.Imgs,
                                      limit: 5,
                                      "list-type": "picture-card",
                                      "on-preview":
                                        _vm.handlePictureCardPreview,
                                      "on-success": _vm.handleAvatarSuccess,
                                      "on-remove": _vm.handleRemove,
                                      "on-exceed": _vm.handleExceed,
                                      "before-upload": _vm.beforeAvatarUpload,
                                      disabled: _vm.disabled,
                                    },
                                  },
                                  [
                                    !_vm.disabled
                                      ? _c("i", { staticClass: "el-icon-plus" })
                                      : _vm._e(),
                                    _vm.disabled
                                      ? _c("i", {
                                          staticClass: "el-icon-close",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse",
                      {
                        model: {
                          value: _vm.activeNames,
                          callback: function ($$v) {
                            _vm.activeNames = $$v
                          },
                          expression: "activeNames",
                        },
                      },
                      [
                        _vm.form.WorkOrderType === "2" ||
                        _vm.form.WorkOrderType === "3"
                          ? _c(
                              "el-collapse-item",
                              { attrs: { title: "故障描述", name: "1" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#f56c6c" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 故障描述    "),
                                ]),
                                _c(
                                  "el-row",
                                  [
                                    _vm.form.WorkOrderType === "2" ||
                                    _vm.form.WorkOrderType === "3"
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: " ",
                                                  prop: "FaultDescription",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "",
                                                    type: "textarea",
                                                    rows: "10",
                                                    resize: "none",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.FaultDescription,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "FaultDescription",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.FaultDescription",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-collapse-item",
                          { attrs: { title: "建议描述", name: "2" } },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "span",
                                { staticStyle: { color: "#f56c6c" } },
                                [_vm._v("*")]
                              ),
                              _vm._v(" 建议描述 "),
                            ]),
                            _c(
                              "el-row",
                              { staticStyle: { "padding-bottom": "50px" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: { label: " ", prop: "Remarks" },
                                  },
                                  [
                                    !_vm.disabled
                                      ? _c("quill-editor", {
                                          ref: "myQuillEditor",
                                          staticStyle: { height: "600px" },
                                          attrs: { options: _vm.editorOption },
                                          model: {
                                            value: _vm.form.Remarks,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "Remarks", $$v)
                                            },
                                            expression: "form.Remarks",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.disabled
                                      ? _c("div", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "600px",
                                            overflow: "auto",
                                            border: "1px solid #e2e2e2",
                                            padding: "10px",
                                            "background-color": "#f5f7fa",
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(_vm.form.Remarks),
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _c(
                          "el-collapse-item",
                          { attrs: { title: "备件信息", name: "3" } },
                          [
                            _c(
                              "el-row",
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "30px" } },
                                  [
                                    !_vm.disabled
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.addList },
                                          },
                                          [_vm._v("添加备件")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-table",
                                  {
                                    ref: "MaterialsData",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.MaterialsData,
                                      height: "400px",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "序号",
                                        width: "50",
                                        type: "index",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "备件编号",
                                        align: "center",
                                        prop: "Code",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "备件名称",
                                        align: "center",
                                        prop: "Name",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "备件类型",
                                        align: "center",
                                        prop: "MaterialTypeName",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "备件规格",
                                        align: "center",
                                        prop: "Spec",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "单位",
                                        align: "center",
                                        prop: "storageName",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "货位",
                                        align: "center",
                                        prop: "LocalName",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "库存数量",
                                        align: "right",
                                        prop: "Nums_N",
                                        sortable: "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "数量",
                                        align: "center",
                                        prop: "Num",
                                        sortable: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: _vm.disabled,
                                                    type: "number",
                                                    controls: false,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.NumChange(
                                                        $event,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.Num,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "Num",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "scope.row.Num",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        478268593
                                      ),
                                    }),
                                    !_vm.disabled
                                      ? _c("el-table-column", {
                                          attrs: {
                                            label: "操作",
                                            align: "center",
                                            prop: "op",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          color: "#f78989",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.MaterialsData.splice(
                                                              scope.$index,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("删除")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4135523204
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("DevDialog", {
        ref: "DevDialog",
        attrs: { type: "radio" },
        on: { select: _vm.handleDevSelect },
      }),
      _c("FittingsOut", {
        ref: "FittingsOut",
        on: { select: _vm.selectFittingsOut },
      }),
      _c("AIDrawer", { ref: "AIDrawer", on: { AI: _vm.AISub } }),
      _c("Supplier", {
        ref: "Supplier",
        attrs: { type: "radio" },
        on: { select: _vm.selectSup },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }